module.exports = "/packs/images/svg/arrow_right~c61421130666ad11dd35b3ef5b49f76d.svg";